import React from 'react';
import { StepSummaryForm } from './step-summary-types';
import { ProcessForm } from '../empowerment-requests-types';

export function StepSummaryLabel({
  stepValues,
}: {
  stepValues?: StepSummaryForm;
  allValues?: ProcessForm;
}) {
  const state = stepValues?.isSent ? 'Odesláno' : '-';

  return (
    <>
      Stav žádosti: <b>{state}</b>
    </>
  );
}
